import { all, call, put, takeLatest } from 'redux-saga/effects'
import agent from 'agent'

import * as actions from 'redux/actions/billing.actions'
import { getCurrentUserSuccess } from 'redux/actions/user.actions'
import { getAccountDataSuccess } from 'redux/actions/account.actions'

function* changePlanSaga(params) {
  try {
    const { payload } = params.payload
    const body = yield call(agent.Billing.changePlan, payload)
    const status = body.status

    let message = ''
    if (status === 'success') {
      message = body.message
    } else if (status === 'error') {
      message = body.errors.error
    }

    yield put(actions.changePlanSuccess(message))

    yield call(refreshUserAccount)
  } catch (error) {
    if (error.response.status === 422) {
      yield put(actions.changePlanFailure(error.response.body.errors))
    }
  }
}

function* purchaseAddonSaga(params) {
  try {
    const { payload } = params.payload
    const body = yield call(agent.Billing.purchaseAddon, payload)
    yield put(actions.purchaseAddOnSuccess(body.data))
  } catch (error) {
    yield put(actions.purchaseAddOnFailure(error))
  }
}

function* refreshUserAccount() {
  // Refresh user and account details
  const body = yield call(agent.Auth.current)
  const user = body.data.attributes
  const id = body.data.id
  const account = yield call(agent.Auth.account)

  yield put(getCurrentUserSuccess(user, id))
  yield put(getAccountDataSuccess(account))
}

function* loadInvoicesSaga() {
  try {
    const body = yield call(agent.Billing.getInvoices)
    yield put(actions.loadInvoicesSuccess(body.data))
  } catch (error) {
    yield put(actions.loadInvoicesFailure(error))
  }
}

export default function* billingSagas() {
  yield all([
    takeLatest(actions.changePlan.type, changePlanSaga),
    takeLatest(actions.purchaseAddOn.type, purchaseAddonSaga),
    takeLatest(actions.loadInvoices.type, loadInvoicesSaga)
  ])
}
